import * as React from "react";
import {
  Box,
  createStyles,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";

import { Source } from "services/valuation/types";
import theme from "theme";
import { REGULAR_CHART_COLOR_LIST } from "theme/constants";

import SourceBreakdownChart from "./SourceBreakdownChart";
import SourceBreakdownTable from "./SourceBreakdownTable";

const useStyles = makeStyles(() =>
  createStyles({
    sourceBreakDownContainer: {
      maxWidth: "500px",
    },
    sourceBreakDownTitle: {
      fontSize: "18px",
      fontWeight: theme.typography.fontWeightBold,
    },
    sourceBreakDownSubtitle: {
      fontSize: "14px",
    },
  }),
);

export interface SourceBreakDownProps {
  sources: Source[];
  totalValue: number;
  colorList?: string[];
  title: string;
  subtitle?: string;
  pieChartHeight?: number;
}

const SourceBreakdown: React.FC<SourceBreakDownProps> = ({
  sources,
  colorList,
  title,
  subtitle,
  totalValue,
  pieChartHeight,
}) => {
  const classes = useStyles();

  const COLORS = colorList || REGULAR_CHART_COLOR_LIST;

  const colors: string[] = [];
  sources.forEach((_s, i) => {
    colors[i] = COLORS[i];
  });

  const formattedSources = sources.map(s => ({
    name: s.name,
    earnings: s.earnings,
    earning_details: s.earning_details,
  }));

  return (
    <Box>
      <Grid container className={classes.sourceBreakDownContainer}>
        <Grid item xs={12} sm={6}>
          <Typography className={classes.sourceBreakDownTitle}>
            {title}
          </Typography>
          <Typography className={classes.sourceBreakDownSubtitle}>
            {subtitle}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <SourceBreakdownChart
            colors={colors}
            sources={formattedSources}
            totalValue={totalValue}
            pieChartHeight={pieChartHeight}
          />
        </Grid>
        <Grid item xs={12}>
          <SourceBreakdownTable
            colors={colors}
            sources={formattedSources}
            totalValue={totalValue}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
export default SourceBreakdown;
